import { all, fork } from 'redux-saga/effects'
import buyCardsSagas from './buyCards'
import visaCardsSagas from './visaCards'
import orderStatusSagas from './orderStatus'
import buyBulkSagas from './buyBulk'
import smbCartSagas from './smbCart'
import createACardSagas from './createACard'
import orderDetailsSagas from './orderDetails'

export default function* rootSaga() {
    yield all([
        fork(buyCardsSagas),
        fork(visaCardsSagas),
        fork(orderStatusSagas),
        fork(buyBulkSagas),
        fork(smbCartSagas),
        fork(createACardSagas),
        fork(orderDetailsSagas),
    ])
}
